export default __webpack_public_path__ + "static/SRUS SSC300 - Product Specifications & Technical Data-de19425b7814d5d85e996f4e66b0cb33.pdf";